import {
  RouterProvider,
} from "react-router-dom";
import router from "./router";

// App Component
function App() {

  return <RouterProvider router={router} />;
}

export default App;
